import React from 'react';
import { Container, Typography, Paper, Box, Divider } from '@mui/material';

export default function Privacy() {
    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
                <Typography variant="h4" fontWeight={800} gutterBottom>
                    Datenschutzerklärung
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                    Stand: 06. Januar 2026
                </Typography>
                
                <Divider sx={{ my: 3 }} />

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        1. Datenschutz auf einen Blick
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Wir freuen uns über Ihr Interesse an unserer Anwendung. Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Nachfolgend informieren wir Sie darüber, welche Daten wir erfassen und wie wir diese verarbeiten.
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        2. Verantwortliche Stelle
                    </Typography>
                    <Typography variant="body1">
                        Verantwortlich für die Datenverarbeitung in dieser Anwendung ist:
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1, fontWeight: 500 }}>
                        Albert Tools<br />
                        E-Mail: service@albert.tools
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        3. Datenerfassung in der Anwendung
                    </Typography>
                    <Typography variant="hsubtitle1" fontWeight={600} gutterBottom>
                        Registrierung und Account-Daten
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Bei der Registrierung erfassen wir Ihren Namen, Ihre E-Mail-Adresse und Ihre Anschrift. Diese Daten werden zur Bereitstellung unserer Dienste sowie für die Abrechnung über unseren Partner Mollie benötigt.
                    </Typography>
                    <Typography variant="hsubtitle1" fontWeight={600} gutterBottom>
                        Zahlungsdaten
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Zahlungen werden über den externen Dienstleister Mollie B.V. abgewickelt. Wir speichern keine vollständigen Kreditkarteninformationen, sondern lediglich die von Mollie vergebene Kunden- und Zahlungs-ID zur Zuordnung Ihres Abonnements.
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        4. Analyse und Telemetrie
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Zur Verbesserung unserer Anwendung erfassen wir anonymisierte Nutzungsdaten (z. B. Fehlerberichte aus dem Frontend). Diese Daten lassen keinen direkten Rückschluss auf Ihre Person zu und dienen ausschließlich der technischen Optimierung.
                    </Typography>
                </Box>

                <Box>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        5. Ihre Rechte
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
}
